import { render } from "./DadosEmpresa.vue?vue&type=template&id=1234a32a&scoped=true"
import script from "./DadosEmpresa.vue?vue&type=script&lang=js"
export * from "./DadosEmpresa.vue?vue&type=script&lang=js"

import "./DadosEmpresa.vue?vue&type=style&index=0&id=1234a32a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1234a32a"]])

export default __exports__